import { Color, parseColor } from '@ark-ui/react'
import { safeParseColor } from '@qr-front/ui/utils'
import { hex } from 'wcag-contrast'

const MIN_OPAQUE_ALPHA = 0.5

export const getContrastingNeutralColor = (color: Color | string) => {
	if (!color) {
		return 'white'
	}

	const parsedColor =
		typeof color === 'string' ? safeParseColor(parseColor)(color) : color

	if (!parsedColor) {
		return 'black'
	}

	if (parsedColor.getChannelValue('alpha') < MIN_OPAQUE_ALPHA) {
		return 'black'
	}

	const colorStr = parsedColor.toString('hex')

	const whiteContrast = hex(colorStr, '#FFFFFF')

	return whiteContrast >= 1.5 ? 'white' : 'black'
}
